import React from 'react';

import { formatCurrency } from 'js/services/Format';

import Row from './Row';
import Label from './Label';
import Value from './Value';
import styled from "styled-components";

const Disabled = styled.div`
  color: #aaa;
`;

export default ({ label, onClick, children }) => (
  <Row>
    <Label><a href="#" onClick={onClick}>{label}</a></Label>
    <Value><Disabled>-{formatCurrency(children)}</Disabled></Value>
  </Row>
);
